var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"action",attrs:{"title":_vm.text}},[_c('svg',{attrs:{"width":"1em","height":"1em","fill":"currentColor"}},[_c('use',{attrs:{"xlink:href":'#' + _vm.type}})])])}
var staticRenderFns = []

export { render, staticRenderFns }